import { type ReactElement } from 'react';
import { FaSpinner } from 'react-icons/fa';
import './index.css';
import { Box } from '@mui/material';

const Spinner = (): ReactElement => (
  <Box className='spinner-overlay'>
    <Box className='spinner-container'>
      <Box className='lds-ripple'>
        <FaSpinner className='loading-icon' />
      </Box>
    </Box>
  </Box>
);

export default Spinner;
